var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSrsTracker(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.0278 14.5161C19.0274 15.7507 18.6054 16.9482 17.8316 17.9102C17.0579 18.8723 15.9788 19.5413 14.773 19.8064L14.197 18.0785C14.7245 17.9916 15.2261 17.7888 15.6657 17.4847C16.1053 17.1806 16.4719 16.7828 16.7392 16.3199H14.5139C14.035 16.3199 13.5758 16.1297 13.2372 15.791C12.8986 15.4524 12.7083 14.9932 12.7083 14.5143V10.9032C12.7083 10.4243 12.8986 9.9651 13.2372 9.62649C13.5758 9.28788 14.035 9.09766 14.5139 9.09766H17.1663C16.946 7.35249 16.0964 5.74769 14.777 4.58438C13.4576 3.42106 11.759 2.77918 10 2.77918C8.24099 2.77918 6.54243 3.42106 5.22302 4.58438C3.90362 5.74769 3.05406 7.35249 2.83376 9.09766H5.48612C5.96498 9.09766 6.42423 9.28788 6.76284 9.62649C7.10145 9.9651 7.29167 10.4243 7.29167 10.9032V14.5143C7.29167 14.9932 7.10145 15.4524 6.76284 15.791C6.42423 16.1297 5.96498 16.3199 5.48612 16.3199H2.77778C2.29892 16.3199 1.83967 16.1297 1.50106 15.791C1.16246 15.4524 0.972229 14.9932 0.972229 14.5143V10.0004C0.972229 5.01439 5.01397 0.972656 10 0.972656C14.986 0.972656 19.0278 5.01439 19.0278 10.0004V14.5161Z",
    fill: "#737981"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSrsTracker);
export default __webpack_public_path__ + "static/media/srs-tracker.2ed7c5940ed5b5d2056d20b9a664d419.svg";
export { ForwardRef as ReactComponent };